export const APP_PRODUCT_ROUTE = 'product';
